import { LogGroup, Log } from "../.././MyHelpers";
import { ReelSpinAnimation } from "./ReelSpinAnimation";
import { SpinTargetParams } from "./SpinTargetParams"
export class SpinTarget {
	public position: number = 0;
	public anticipate: boolean = false;
}

export type SpinCallback = () => void;

export class SpinAnimation {

	private reelAnimations: ReelSpinAnimation[] = [];
	private onStartCallbacks: SpinCallback[] = [];
	private onCompleteCallbacks: SpinCallback[] = [];

	private logGroup: LogGroup = null;
	private running: boolean = false;
	private targetsSet: boolean = false;
	private stopRequested: boolean = false;
	private reelsFinished: number = 0;

	public constructor(logGroup: LogGroup) {
		this.logGroup = logGroup.Add("SpinAnim");
	}

	public AddReelAnimation(anim: ReelSpinAnimation): void {
		// connect reel animations 
		if (this.reelAnimations.length > 0) {
			this.reelAnimations[this.reelAnimations.length -1].AddOnCompleteCallback(() => anim.OnPreviousReelSpinEnd());
		}

		anim.AddOnCompleteCallback(() => this.ReelFinished());

		this.reelAnimations.push(anim);	
	}

	public ReelFinished(): void {
		// Log.Debug(this.logGroup, "Reel finished");
		this.reelsFinished++;

		if (this.reelsFinished == this.reelAnimations.length) {
			this.OnComplete();
		}
	}

	public Start(): void {

		if (this.running)
		{
			// already started
			return;
		}
		this.running = true;

		this.targetsSet = false;
		this.stopRequested = false;
		this.reelsFinished = 0;

		// console.log("SpinAnimation started");

		for (let i = 0; i < this.reelAnimations.length; i++) {
			this.reelAnimations[i].Start();
		}

		this.OnStart();
	}

	public Cancel(): void {
		if (!this.running)
		{
			return;
		}

		this.running = false;
		for (let i = 0; i < this.reelAnimations.length; i++) {
			this.reelAnimations[i].Cancel();
		}
	}

	public SetTargets(targets: SpinTargetParams[]): void {
		if (targets.length != this.reelAnimations.length) {
			Log.Error(this.logGroup, "Expected " + this.reelAnimations.length + " targets, got " + targets.length);
			return;
		}

		this.targetsSet = true;

		// console.log(`SpinAnimation have targets, requesting stop: ${this.stopRequested}`);

		for (let i = 0; i < this.reelAnimations.length; i++) {
			this.reelAnimations[i].SetTarget(targets[i]);
		}

		if (this.stopRequested)
		{
			for (let i = 0; i < this.reelAnimations.length; i++)
			{
				this.reelAnimations[i].RequestStop();
			}
		}
	}

	public Update(): void {
		for (let i = 0; i < this.reelAnimations.length; i++) {
			this.reelAnimations[i].Update();
		}
	}

	// callback will be called, when spin starts
	public AddOnStartCallback(callback: SpinCallback) {
		this.onStartCallbacks.push(callback);
	}

	private OnStart(): void {
		for (let i = 0; i < this.onStartCallbacks.length; i++) {
			this.onStartCallbacks[i]();
		}
	}

	// callback will be called, when win nanimation has completed
    public AddOnCompleteCallback(callback: SpinCallback) {
        this.onCompleteCallbacks.push(callback);
    }

    private OnComplete(): void {
		this.running = false;

        for (let i = 0; i < this.onCompleteCallbacks.length; i++) {
            this.onCompleteCallbacks[i]();
        }
    }

    public RequestStop(reelIndex: number = -1): void {
		// console.log("SpinAnimation Requesting stop");
    	if (!this.stopRequested) {


    		// are we stopping all reels, or individual?
    		// if (reelIndex == -1)
            {
				// stop all reels

	    		// check, if all reels are ready to stop
	    		// let allReelsStopAvailable = true;
	    		// for (let i = 0; i < this.reelAnimations.length; i++) {
	    		// 	if (!this.reelAnimations[i].CheckStopAvailable()) {
	    		// 		allReelsStopAvailable = false;
	    		// 		break;
	    		// 	}
	    		// }

	    		
				this.stopRequested = true;

				// stop all reels only, if all of them are available to stop
				
	    		if (this.targetsSet)
				{
					// console.log("SpinAnimation Stop requested, have targets");
					for (let i = 0; i < this.reelAnimations.length; i++)
					{
			    		this.reelAnimations[i].RequestStop();
			    	}
	    		}
	    		else
				{
			    	// console.log("SpinAnimation Can't request stop, not all reels are ready to stop");
			    }
			}

			// // are we stopping specific reel?
			// else if (reelIndex >= 0 && reelIndex < this.reelAnimations.length) {

			// 	// make sure stop is available on this reel
			// 	if (this.reelAnimations[reelIndex].CheckStopAvailable()) {
			// 		this.reelAnimations[reelIndex].RequestStop();
			// 	}
			// 	else {
			// 		// Log.Debug(this.logGroup, "Stop request on reel " + reelIndex + " not available yet");
			// 	}
			// }
			// else {
			// 	// Log.Debug(this.logGroup, "Expected reel index -1 or [0.." + (this.reelAnimations.length -1) + "], but got " + reelIndex);
			// }
	    }
	    else {
	    	// console.log("SpinAnimation Stop already requested");
	    }
    }
}